
import { PropValidator } from '@/types'
import { logException } from '@/utils/log'
import { at, debounce, isArray, isFunction, isEqual } from 'lodash'
import Vue from 'vue'

export default Vue.extend({
  props: {
    searchInput: { type: String, required: false },
    callback: Function,
    args: { type: Array, default: () => [] },
    delay: { type: Number, default: 500 },
    itemValue: { type: [String, Array, Function], default: 'value' } as PropValidator<string | Array<string> | (() => ((...args: unknown[]) => unknown))>,
    returnObject: { type: Boolean, default: false },
    value: { required: false },
  },
  data() {
    return {
      debounced: debounce((callback: (arg: unknown) => void, value: unknown) => { callback(value) }, this.delay),
      loading: false,
      items: [] as unknown[],
      innerValue: undefined as unknown,
      bannedValue: undefined as unknown,
    }
  },
  methods: {
    input(value: Record<string, unknown> | string | undefined) {
      this.innerValue = value
      let tmp
      if (typeof value === 'object' && !this.returnObject) {
        if (isFunction(this.itemValue)) {
          tmp = this.itemValue(value)
        } else if (isArray(this.itemValue)) {
          tmp = at(value, this.itemValue)
        } else {
          [tmp] = at(value, this.itemValue)
        }
      } else {
        tmp = value
      }
      this.bannedValue = tmp
      this.$emit('input', tmp)
    },
    query(value: unknown) {
      if (value !== undefined && value !== null) {
        this.debounced(this.afterQuery, value)
      }
    },
    async afterQuery(value: unknown) {
      this.loading = true
      try {
        this.items = await this.callback(value, ...this.args)
      } catch (e) {
        logException(`le callback ${this.callback.name} a rencontré un problème`)
        this.items = []
      }
      this.loading = false
    },
  },
  computed: {
    keyedSlots(): unknown {
      return Object.entries({ ...this.$scopedSlots, ...this.$slots })
    },
  },
  watch: {
    searchInput: {
      handler(val) {
        if (val !== undefined && val !== null) {
          this.afterQuery(val)
        }
      },
      immediate: true,
    },
    value: {
      handler(val: unknown) {
        if (!isEqual(val, this.bannedValue)) {
          this.innerValue = val
        }
      },
      immediate: true,
      deep: true,
    },
  },
})
